import { useNavigate } from 'react-router-dom';
import { NavigationItem } from './NavigationItem';
import { NavigationItem as NavItem } from '../../hooks/useNavigation';
import { useNavigationState } from '../../hooks/useNavigationState';

interface NavigationListProps {
  items: NavItem[];
  isSidebarCollapsed: boolean;
  onOracleClick?: () => void;
}

export function NavigationList({ items, isSidebarCollapsed, onOracleClick }: NavigationListProps) {
  const navigate = useNavigate();
  const { isItemActive, isItemAccessible, isItemVisible } = useNavigationState();

  const handleNavItemClick = (e: React.MouseEvent, item: NavItem) => {
    const isAccessible = isItemAccessible(item);

    // Handle Oracle submenu - show submenu but allow navigation
    if (item.href === '/oracle' && onOracleClick) {
      onOracleClick();
      // Don't prevent default, let the Link navigate normally
    }

    if (!isAccessible) {
      e.preventDefault();
      navigate('/account?tab=subscription');
    }
  };

  return (
    <>
      {items.map((item) => {
        if (!isItemVisible(item)) {
          return null;
        }

        return (
          <NavigationItem
            key={item.href}
            item={item}
            isActive={isItemActive(item)}
            isAccessible={isItemAccessible(item)}
            isSidebarCollapsed={isSidebarCollapsed}
            onClick={handleNavItemClick}
          />
        );
      })}
    </>
  );
}
